import { COUNTRY_CODES } from '@/constants/countryCodes'

export const getCountryFromDate = () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return COUNTRY_CODES.find((country) => country.timeZone === timeZone)?.name ?? ''
}
